import type { ReactNode } from 'react';
import type { PageLayoutData } from '../layout/types';

type PagePositionTransformProps = {
  layout: PageLayoutData;
  children: ReactNode;
};

export const PagePositionTransform = ({
  layout,
  children,
}: PagePositionTransformProps) => {
  const centerX = layout.x + layout.width / 2;
  const centerY = layout.y + layout.height / 2;

  return <g transform={`translate(${centerX}, ${centerY})`}>{children}</g>;
};
